module.exports = __webpack_public_path__ + "b76db953829e898304f885b864ea7f7c.png";